import React from "react";
import {DatePicker, Form, Input, Popover, Table, Tooltip, Button} from "antd";
import {TrackHeaderLink} from "../TrackHeaderLink";
import {WorkOrderList, WorkOrderPDFList} from "../../../models/workorder";
import {ShowReport} from "./popups/ShowReport";
import {pagination} from "../../../controller/Utils";
import {AdvancedSearchReport} from "./popups/AdvanceSearchReport";

const {RangePicker} = DatePicker;
const Search = Input.Search;
const _ = require('lodash');

class ReportPage extends React.Component {
  state = {
    visible: false,
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    update: false,
    data: [],
    params: {},
    pdfLoading: false
  };
  onRowShowClick = (ids) => {
    this.setShowWorkOrderModel(true);
    this.setState({showWorkOrderModelData: ids})
  };
  columns = [
    {
      title: 'View',
      key:'id',
      render: (item) => <div className="action-column">
        <a title="View" onClick={() => this.onRowShowClick([item.id])}><i className="fa fa-eye"/></a>
      </div>
    }, {
      title: 'Service Date',
      dataIndex: 'service',
      key: 'service__service_date',
      render: (service) =>
        <Popover className="services-popover" content={
          <div className="service-date-pop">
            {service.map((item, index) => <p key={index}>{item.service_date}<Tooltip title={item.status}><span className={"status-services " + (item.status)}><i className="fa fa-circle" /></span></Tooltip></p>)}
          </div>} title="All Service Date">
          <a type="primary">{_.get(service, '0.service_date')} <i className="fa fa-info-circle" /></a>
        </Popover>,
      sorter: true

    }, {
      title: 'Generator',
      dataIndex: 'generator.company_name',
      key: 'generator',
      sorter: true
    }, {
      title: 'Manifest/BOL',
      dataIndex: 'service',
      key: 'service__type',
      render: service => service.map(service => service.manifest_number).join(', '),
    }, {
      title: 'Waste Stream',
      dataIndex: 'service',
      render: service => service.map(service => service.waste_data.map(ws => _.get(ws, 'waste_stream.code')).join(', ')).join(' | ')
    },{
      title: 'Material',
      dataIndex: 'service',
      key: 'material',
      render: service =>  <Popover content={
          <div className="service-date-pop">
            {service.map(service => service.waste_data.map((item, index) => <p key={index}>
              <span>{_.get(item, 'waste_stream.code')} : {_.get(item, 'waste_stream.description')}</span></p>))}
          </div>} title="All Materials">
          <a type="primary">Show Material<i className="fa fa-info-circle" /></a>
        </Popover>
    }, {
      title: 'Unit',
      dataIndex: 'service',
      key: 'unit',
      render: service => service.map(service => service.waste_data.map((ws) => _.get(ws, 'waste_stream.unit')).join(', ')).join(' | '),
    }, {
      title: 'Quantity',
      dataIndex: 'service',
      key: 'quantity',
      render: service => service.map(service => service.waste_data.map((ws) => ws.quantity ? ws.quantity : '--').join(', ')).join(' | '),
    },{
      title: 'Transporter',
      dataIndex: 'service.0.transporter.name',
    },{
      title: 'Facility',
      dataIndex: 'service.0.facility.name',
    },{
      title: 'User',
      dataIndex: 'user',
      render: user => user? `${user.first_name} ${user.last_name}`: "N/A"
    },
  ];
  handleTableChange = (pagination, filters, sorter) => {
    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.columnKey}`,
      ...filters,
    });
  };

  fetch = (params = {}, reset=false) => {
    if (!reset)
      params =  {...this.state.params, ...params};
    this.setState({loading: true, params});
    WorkOrderList(params)
      .then(response => {
        const pagination = {...this.state.pagination};
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };

  getReportData = () => {
    const {data} = this.state;
    const report = {};
    const html = [];
    data.forEach(function (item) {
      item.service.forEach(function (service) {
        service.waste_data.forEach(function (waste) {
          const code = _.get(waste, 'waste_stream.code');
          let qt = _.get(waste, 'quantity', 0);
          report[code] = report[code]? report[code] + qt :qt ;
        })
      })
    });
    for (let key in report) {
      html.push(<div key={key} className="count-tags">{key}:<span> {report[key]? report[key].toFixed(2): 0}</span></div>)
    }
    return html
  };

  advanceFilter = (response, params) => {
    this.setState({loading: true, params});
    const pagination = {...this.state.pagination};
    pagination.total = response.data.count;
    this.setState({
      loading: false,
      data: response.data.results,
      pagination,
    });
  };

  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'service__service_date',
      start_date: dateString[0],
      end_date: dateString[1],
        page: 1
    })
  };

  printGeneratorReport = () => {
    const {params} = this.state;
    params['pdf_type'] = 'report_generator';
    this.setState({pdfLoading: true});
    WorkOrderPDFList(params)
        .then(() => {
          this.setState({pdfLoading: false})
        })
  };

  setShowWorkOrderModel(showWorkOrderModel) {
    this.setState({showWorkOrderModel});
  }

  componentDidMount() {
    this.fetch();
  }

  render() {
    const {pagination, loading, data, params, pdfLoading} = this.state;
    pagination.current = params.page || 1;
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-3 col-12">
                <h3 className="main-heading">AB Tracks</h3>
              </div>
              <div className="col-sm-9 col-12">
                <TrackHeaderLink/>
              </div>
            </div>
            <div className="row clearfix edit-header">
              <div className="col-lg-4 col-sm-4 col-12">
                <div id="date_range_wrapper">
                  <RangePicker onChange={this.onDateRangeChange}/>
                </div>
              </div>
              <div className="col-lg-3 col-sm-4 col-12">
                <Search placeholder="Input search text" onSearch={value => this.fetch({search: value})}
                        style={{width: "100%"}}/>
              </div>
              <div className="col-lg-2 col-sm-4 col-12">
                <AdvancedSearchReport params={params} resetFilter={() => this.fetch({}, true)} advanceFilter={(response, params) => this.advanceFilter(response, params)}/>
              </div>
              <div className="col-lg-3 col-sm-12 col-12 edit-div">
                <span>{pagination.total} Records</span>
                <Tooltip title="Report">
                  <Button className="btn btn-edit" loading={pdfLoading} onClick={this.printGeneratorReport}>
                    <i className="fa fa-print "/>
                  </Button>
                </Tooltip>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-12">
                <div className="listing-table">
                  <Table className="report-table responsive-table table table-hover js-basic-example dataTable
                  table-custom table-striped m-b-0 c_list" pagination={pagination} rowKey={data => data.id}
                         columns={this.columns} dataSource={data} loading={loading} onChange={this.handleTableChange}
                    locale={{emptyText: 'No Work Order Available'}}/>
                  <div className="count-tag-row">
                    {this.getReportData()}
                  </div>
                </div>
              </div>
              <ShowReport visible={this.state.showWorkOrderModel} setModelVisible={() => this.setShowWorkOrderModel(false)} data={this.state.showWorkOrderModelData}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const Report = Form.create()(ReportPage);


// WEBPACK FOOTER //
// ./src/pages/tracks/report/Report.jsx